export const USER_CHANGED_INPUT_TEXT = 'grmr/user/changed_input_text';
export const HAS_GRAMMAR_ERROR = 'grmr/system/has_grammar_error';
export const IS_GRAMMAR_CHECK_RUNNING = 'grmr/system/is_grammar_check_running';
export const PARAPHRASER_RECEIVED_GRAMMAR_CHECK_DATA =
  'grmr/system/paraphraser_received_grammar_check_data';
export const USER_CLICKED_COPY_BUTTON = 'grmr/user/clicked_copy_button';
export const USER_CLICKED_INSERT_TO_DOC = 'grmr/user/clicked_insert_into_doc';
export const USER_CLICKED_CORRECT_ALL_BUTTON = 'grmr/user/clicked_correct_all_button';
export const USER_CLICKED_IGNORE_ERROR = 'grmr/user/clicked_ignore_error';
export const USER_CLICKED_DELETE_TEXT = 'grmr/user/clicked_delete_text';
export const USER_OPENED_CORRECTION_CARD = 'grmr/user/opened_correction_card';
export const USER_CLICKED_CORRECT_ERROR = 'grmr/user/clicked_correct_error';
export const USER_CLICKED_PARAPHRASE_BUTTON = 'grmr/user/clicked_paraphrase_button';
export const USER_PASTED_TEXT = 'grmr/user/pasted_text';
export const SET_SETTING_VALUE = 'grmr/user/set_setting_value';
export const STATS_AVAILABLE = 'grmr/system/stats_available';
export const USER_EXCEEDED_INPUT_LIMIT = 'grmr/user/input_limit_exceeded';
export const GRAMMAR_CHECK_COMPLETED = 'grmr/system/grammar_check_completed';
export const SET_GC_LANGUAGE = 'grmr/system/set_language';
export const HYDRATE_STORE_FROM_SESSION = 'grmr/system/hydrate_store_from_session';
